var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.25 11.5C18.25 10.4393 18.25 9.90901 18.5795 9.57951C18.909 9.25 19.4394 9.25 20.5 9.25C21.5606 9.25 22.091 9.25 22.4205 9.57951C22.75 9.90901 22.75 10.4393 22.75 11.5C22.75 12.5607 22.75 13.091 22.4205 13.4205C22.091 13.75 21.5606 13.75 20.5 13.75C19.4394 13.75 18.909 13.75 18.5795 13.4205C18.25 13.091 18.25 12.5607 18.25 11.5Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.25 20.5C9.25 19.4394 9.25 18.909 9.57951 18.5795C9.90901 18.25 10.4393 18.25 11.5 18.25C12.5607 18.25 13.091 18.25 13.4205 18.5795C13.75 18.909 13.75 19.4394 13.75 20.5C13.75 21.5606 13.75 22.091 13.4205 22.4205C13.091 22.75 12.5607 22.75 11.5 22.75C10.4393 22.75 9.90901 22.75 9.57951 22.4205C9.25 22.091 9.25 21.5606 9.25 20.5Z",
    fill: "#2C8C53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.5C9.25 10.4393 9.25 9.90901 9.57951 9.57951C9.90901 9.25 10.4393 9.25 11.5 9.25C12.5607 9.25 13.091 9.25 13.4205 9.57951C13.75 9.90901 13.75 10.4393 13.75 11.5C13.75 12.5607 13.75 13.091 13.4205 13.4205C13.091 13.75 12.5607 13.75 11.5 13.75C10.4393 13.75 9.90901 13.75 9.57951 13.4205C9.25 13.091 9.25 12.5607 9.25 11.5Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 20.5C9.25 19.4394 9.25 18.909 9.57951 18.5795C9.90901 18.25 10.4393 18.25 11.5 18.25C12.5607 18.25 13.091 18.25 13.4205 18.5795C13.75 18.909 13.75 19.4394 13.75 20.5C13.75 21.5606 13.75 22.091 13.4205 22.4205C13.091 22.75 12.5607 22.75 11.5 22.75C10.4393 22.75 9.90901 22.75 9.57951 22.4205C9.25 22.091 9.25 21.5606 9.25 20.5Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 16H13.75",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.25V13",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 11.5C18.25 10.4393 18.25 9.90901 18.5795 9.57951C18.909 9.25 19.4394 9.25 20.5 9.25C21.5606 9.25 22.091 9.25 22.4205 9.57951C22.75 9.90901 22.75 10.4393 22.75 11.5C22.75 12.5607 22.75 13.091 22.4205 13.4205C22.091 13.75 21.5606 13.75 20.5 13.75C19.4394 13.75 18.909 13.75 18.5795 13.4205C18.25 13.091 18.25 12.5607 18.25 11.5Z",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 16H18.25C17.1894 16 16.659 16 16.3295 16.3295C16 16.659 16 17.1894 16 18.25M16 20.3269V22.4039M18.25 18.25V19.375C18.25 20.4598 18.8378 20.5 19.75 20.5C20.1642 20.5 20.5 20.8358 20.5 21.25M19 22.75H18.25M20.5 18.25C21.5606 18.25 22.091 18.25 22.4205 18.58C22.75 18.9099 22.75 19.4411 22.75 20.5032C22.75 21.5654 22.75 22.0965 22.4205 22.4265C22.18 22.6674 21.8325 22.7325 21.25 22.75",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qr_icon.7c294850e3d3423276febddbeaeb2200.svg";
export { ForwardRef as ReactComponent };